import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
import { UserFragmentDoc } from '../../fragments/__generated__/User.generated';
import { AddressFragmentDoc } from '../../fragments/__generated__/Address.generated';
import { ProductBaseInfoFragmentDoc } from '../../fragments/__generated__/Product.generated';
import { ProductPriceRangeFragmentDoc } from '../../fragments/__generated__/ProductPriceRange.generated';
import { ReflectionBaseFragmentDoc } from '../../fragments/__generated__/Reflection.generated';
import { OrderBaseFragmentDoc } from '../../fragments/__generated__/Order.generated';
import { InvoiceCompanyFileFragmentDoc } from '../../fragments/__generated__/InvoiceCompanyFile.generated';
import { OrdersCountFragmentDoc } from '../../fragments/__generated__/OrdersCount.generated';
import { UserPatternTransactionFragmentDoc } from '../../fragments/__generated__/UserPatternTransaction.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type MeQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type MeQuery = { me: { id: string, pk: number, firstName: string, lastName: string, isStaff: boolean, isActive: boolean, isSuperuser: boolean, email: string, subscriptions: boolean, permissions: Array<string>, totalPointsBalance: number, totalPointsBalanceAvailable: number, minRpThreshold: number, isImpersonate: boolean, totalBalance: { currency: string, gross: number }, totalBalanceAvailable: { currency: string, gross: number }, customer: { id: string, pk: number, email: string, firstName: string, lastName: string, sendNotifications: boolean, subscribed: boolean, activationCode: string, subscriptionTypes: Array<{ id: string, pk: number, subscriptionType: Types.SubscriptionTypeEnum, name: string, description: string, sortOrder: number }>, discount: { id: string, pk: number, value: any } | null }, wholesaleApp: { id: string, pk: number, created: any, email: string, storeName: string, storeType: Types.StoreTypeEnum, storeYear: number | null, websiteUrl: string | null, instagramUrl: string | null, facebookUrl: string | null, brands: Array<string>, storeDescription: Array<string>, status: Types.WholesaleAppStatusEnum, initialAddress: { firstName: string | null, lastName: string | null, country: Types.CountryCodeEnum | null, city: string | null } | null } | null } | null };

export type MeAddressesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type MeAddressesQuery = { me: { id: string, addresses: Array<{ id: string, pk: number, firstName: string, lastName: string, companyName: string, streetAddress1: string, streetAddress2: string, country: string, city: string, countryArea: string, phone: string, postalCode: string, defaultAddress: boolean, defaultBillingAddress: boolean, defaultShippingAddress: boolean }> } | null };

export type MeFavoritesProductsQueryVariables = Types.Exact<{
  offset: Types.Scalars['Int']['input'];
  limit: Types.Scalars['Int']['input'];
  categories?: Types.InputMaybe<Array<Types.Scalars['Int']['input']> | Types.Scalars['Int']['input']>;
}>;


export type MeFavoritesProductsQuery = { me: { id: string, wishedProducts: { totalCount: number, pageInfo: { limit: number | null, offset: number }, results: Array<{ isInStock: boolean, id: string, pk: number, name: string, sku: string | null, isInFavorites: boolean, isShippingRequired: boolean, isOutOfStock: boolean, thumbnail: { lg: string | null, md: string | null }, priceRange: { id: string, currency: string, discount: { max: number, min: number }, undiscount: { max: number, min: number } }, specifics: Array<{ id: string, pk: number, name: string, shortName: string, videoUrl: string | null, slug: string }> }> } } | null };

export type MeFavoritesCategoriesInfoQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type MeFavoritesCategoriesInfoQuery = { me: { id: string, favoritesCategoriesInfo: Array<{ productsCount: number, category: { id: string, pk: number, name: string, slug: string } }> } | null };

export type MeOrdersQueryVariables = Types.Exact<{
  offset: Types.Scalars['Int']['input'];
  limit: Types.Scalars['Int']['input'];
  withPoints?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  paymentStatus?: Types.InputMaybe<Types.Scalars['String']['input']>;
  status?: Types.InputMaybe<Types.DeliveryGroupStatusEnum>;
  cartType?: Types.InputMaybe<Types.CartTypeEnum>;
  customerDiscountIsNull?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type MeOrdersQuery = { me: { id: string, orders: { totalCount: number, results: Array<{ id: string, pk: number, pubId: string, token: string, created: any, userEmail: string, status: Types.DeliveryGroupStatusEnum, isFullyPaid: boolean, isNotPaid: boolean, isShippingRequired: boolean, isDelivered: boolean, shippingMethodName: string | null, groupLastUpdated: any | null, userId: number | null, giftCardData: any, isGiftCard: boolean, shippingCustomDiscount: any, currency: string, checkoutRate: any, groups: Array<{ id: string, lines: Array<{ id: string, externalId: string, quantity: number, props: string, productSku: string, isCredit: boolean, isSubscription: boolean, productName: string, salesChannelProduct: { id: string, pk: number, slug: string, name: string, thumbnailUrl: string | null } | null, product: { id: string, specifics: Array<{ id: string, pk: number, slug: string }> } | null, variant: { id: string, thumbnailUrl: string | null, properties: Array<{ id: number, attributeName: string, valueName: string }> } | null }> }>, totalNet: { currency: string, gross: number } | null, payments: Array<{ id: string, pk: number, status: string }>, rewardDollars: Array<{ id: string, amount: any, amountSpent: any, dateCreated: any, daysActive: number, isActive: boolean, pointsAmount: number, pointsAmountSpent: number }>, invoiceFiles: Array<{ id: string, pk: number, fileUrl: string, type: string }>, totalTax: { currency: string, gross: number } | null, shippingDiscountAmount: { currency: string, gross: number } }> } } | null };

export type MeOrdersCountQueryVariables = Types.Exact<{
  cartType?: Types.InputMaybe<Types.CartTypeEnum>;
}>;


export type MeOrdersCountQuery = { me: { id: string, ordersCountInfo: { paid: number, unpaid: number, draft: number, issue: number, unapproved: number, approved: number, completed: number } } | null };

export type MeDownloadsQueryVariables = Types.Exact<{
  limit: Types.Scalars['Int']['input'];
  offset: Types.Scalars['Int']['input'];
}>;


export type MeDownloadsQuery = { me: { id: string, downloads: { totalCount: number, pageInfo: { offset: number, limit: number | null }, results: Array<{ id: string, pk: number, fileName: string, downloadTime: any, order: { id: string, pk: number, token: string } }> } } | null };

export type MePatternTransactionsQueryVariables = Types.Exact<{
  offset: Types.Scalars['Int']['input'];
  limit: Types.Scalars['Int']['input'];
  patternType?: Types.InputMaybe<Types.TransactionTypeEnum>;
}>;


export type MePatternTransactionsQuery = { me: { id: string, patternTransactions: { totalCount: number, pageInfo: { limit: number | null, offset: number }, results: Array<{ id: string, date: any, descriptionText: string, patternType: string, patternsCount: number, transactionType: Types.TransactionTypeEnum, order: { id: string, token: string, pubId: string } | null }> } } | null };

export type MePatternPacksInfoQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type MePatternPacksInfoQuery = { me: { id: string, patternPacksInfo: Array<{ id: string, count: number, name: string }> } | null };


export const MeDocument = gql`
    query Me {
  me {
    ...UserFragment
  }
}
    ${UserFragmentDoc}`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export function refetchMeQuery(variables?: MeQueryVariables) {
      return { query: MeDocument, variables: variables }
    }
export const MeAddressesDocument = gql`
    query MeAddresses {
  me {
    id
    addresses {
      ...AddressFragment
    }
  }
}
    ${AddressFragmentDoc}`;

/**
 * __useMeAddressesQuery__
 *
 * To run a query within a React component, call `useMeAddressesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeAddressesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeAddressesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeAddressesQuery(baseOptions?: Apollo.QueryHookOptions<MeAddressesQuery, MeAddressesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeAddressesQuery, MeAddressesQueryVariables>(MeAddressesDocument, options);
      }
export function useMeAddressesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeAddressesQuery, MeAddressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeAddressesQuery, MeAddressesQueryVariables>(MeAddressesDocument, options);
        }
export type MeAddressesQueryHookResult = ReturnType<typeof useMeAddressesQuery>;
export type MeAddressesLazyQueryHookResult = ReturnType<typeof useMeAddressesLazyQuery>;
export type MeAddressesQueryResult = Apollo.QueryResult<MeAddressesQuery, MeAddressesQueryVariables>;
export function refetchMeAddressesQuery(variables?: MeAddressesQueryVariables) {
      return { query: MeAddressesDocument, variables: variables }
    }
export const MeFavoritesProductsDocument = gql`
    query MeFavoritesProducts($offset: Int!, $limit: Int!, $categories: [Int!]) {
  me {
    id
    wishedProducts(
      pagination: {offset: $offset, limit: $limit}
      filters: {categories: $categories}
    ) {
      totalCount
      pageInfo {
        limit
        offset
      }
      results {
        ...ProductBaseInfoFragment
        isInStock
        thumbnail {
          lg(size: "60x0")
          md(size: "300x0", method: THUMBNAIL_WEBP)
        }
        priceRange {
          ...ProductPriceRangeFragment
        }
        specifics(filters: {siteSpecifics: true}) {
          ...ReflectionBaseFragment
        }
      }
    }
  }
}
    ${ProductBaseInfoFragmentDoc}
${ProductPriceRangeFragmentDoc}
${ReflectionBaseFragmentDoc}`;

/**
 * __useMeFavoritesProductsQuery__
 *
 * To run a query within a React component, call `useMeFavoritesProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeFavoritesProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeFavoritesProductsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      categories: // value for 'categories'
 *   },
 * });
 */
export function useMeFavoritesProductsQuery(baseOptions: Apollo.QueryHookOptions<MeFavoritesProductsQuery, MeFavoritesProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeFavoritesProductsQuery, MeFavoritesProductsQueryVariables>(MeFavoritesProductsDocument, options);
      }
export function useMeFavoritesProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeFavoritesProductsQuery, MeFavoritesProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeFavoritesProductsQuery, MeFavoritesProductsQueryVariables>(MeFavoritesProductsDocument, options);
        }
export type MeFavoritesProductsQueryHookResult = ReturnType<typeof useMeFavoritesProductsQuery>;
export type MeFavoritesProductsLazyQueryHookResult = ReturnType<typeof useMeFavoritesProductsLazyQuery>;
export type MeFavoritesProductsQueryResult = Apollo.QueryResult<MeFavoritesProductsQuery, MeFavoritesProductsQueryVariables>;
export function refetchMeFavoritesProductsQuery(variables: MeFavoritesProductsQueryVariables) {
      return { query: MeFavoritesProductsDocument, variables: variables }
    }
export const MeFavoritesCategoriesInfoDocument = gql`
    query MeFavoritesCategoriesInfo {
  me {
    id
    favoritesCategoriesInfo {
      category {
        id
        pk
        name
        slug
      }
      productsCount
    }
  }
}
    `;

/**
 * __useMeFavoritesCategoriesInfoQuery__
 *
 * To run a query within a React component, call `useMeFavoritesCategoriesInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeFavoritesCategoriesInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeFavoritesCategoriesInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeFavoritesCategoriesInfoQuery(baseOptions?: Apollo.QueryHookOptions<MeFavoritesCategoriesInfoQuery, MeFavoritesCategoriesInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeFavoritesCategoriesInfoQuery, MeFavoritesCategoriesInfoQueryVariables>(MeFavoritesCategoriesInfoDocument, options);
      }
export function useMeFavoritesCategoriesInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeFavoritesCategoriesInfoQuery, MeFavoritesCategoriesInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeFavoritesCategoriesInfoQuery, MeFavoritesCategoriesInfoQueryVariables>(MeFavoritesCategoriesInfoDocument, options);
        }
export type MeFavoritesCategoriesInfoQueryHookResult = ReturnType<typeof useMeFavoritesCategoriesInfoQuery>;
export type MeFavoritesCategoriesInfoLazyQueryHookResult = ReturnType<typeof useMeFavoritesCategoriesInfoLazyQuery>;
export type MeFavoritesCategoriesInfoQueryResult = Apollo.QueryResult<MeFavoritesCategoriesInfoQuery, MeFavoritesCategoriesInfoQueryVariables>;
export function refetchMeFavoritesCategoriesInfoQuery(variables?: MeFavoritesCategoriesInfoQueryVariables) {
      return { query: MeFavoritesCategoriesInfoDocument, variables: variables }
    }
export const MeOrdersDocument = gql`
    query MeOrders($offset: Int!, $limit: Int!, $withPoints: Boolean, $paymentStatus: String, $status: DeliveryGroupStatusEnum, $cartType: CartTypeEnum, $customerDiscountIsNull: Boolean) {
  me {
    id
    orders(
      pagination: {offset: $offset, limit: $limit}
      filters: {withPoints: $withPoints, paymentStatus: $paymentStatus, status: $status, cartType: $cartType, customerDiscount: {isNull: $customerDiscountIsNull}}
    ) {
      totalCount
      results {
        ...OrderBaseFragment
        groups {
          id
          lines {
            id
            externalId
            quantity
            props
            productSku
            isCredit
            isSubscription
            salesChannelProduct {
              id
              pk
              slug
              name
              thumbnailUrl(size: "600x0", method: THUMBNAIL_WEBP)
            }
            product {
              id
              specifics(filters: {siteSpecifics: true}) {
                id
                pk
                slug
              }
            }
            productName
            variant {
              id
              thumbnailUrl(size: "600x0", method: THUMBNAIL_WEBP)
              properties {
                id
                attributeName
                valueName
              }
            }
          }
        }
        totalNet {
          currency
          gross
        }
        payments {
          id
          pk
          status
        }
        rewardDollars {
          id
          amount
          amountSpent
          dateCreated
          daysActive
          isActive
          pointsAmount
          pointsAmountSpent
        }
        invoiceFiles {
          ...InvoiceCompanyFileFragment
        }
      }
    }
  }
}
    ${OrderBaseFragmentDoc}
${InvoiceCompanyFileFragmentDoc}`;

/**
 * __useMeOrdersQuery__
 *
 * To run a query within a React component, call `useMeOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeOrdersQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      withPoints: // value for 'withPoints'
 *      paymentStatus: // value for 'paymentStatus'
 *      status: // value for 'status'
 *      cartType: // value for 'cartType'
 *      customerDiscountIsNull: // value for 'customerDiscountIsNull'
 *   },
 * });
 */
export function useMeOrdersQuery(baseOptions: Apollo.QueryHookOptions<MeOrdersQuery, MeOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeOrdersQuery, MeOrdersQueryVariables>(MeOrdersDocument, options);
      }
export function useMeOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeOrdersQuery, MeOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeOrdersQuery, MeOrdersQueryVariables>(MeOrdersDocument, options);
        }
export type MeOrdersQueryHookResult = ReturnType<typeof useMeOrdersQuery>;
export type MeOrdersLazyQueryHookResult = ReturnType<typeof useMeOrdersLazyQuery>;
export type MeOrdersQueryResult = Apollo.QueryResult<MeOrdersQuery, MeOrdersQueryVariables>;
export function refetchMeOrdersQuery(variables: MeOrdersQueryVariables) {
      return { query: MeOrdersDocument, variables: variables }
    }
export const MeOrdersCountDocument = gql`
    query MeOrdersCount($cartType: CartTypeEnum) {
  me {
    id
    ordersCountInfo(cartType: $cartType) {
      ...OrdersCountFragment
    }
  }
}
    ${OrdersCountFragmentDoc}`;

/**
 * __useMeOrdersCountQuery__
 *
 * To run a query within a React component, call `useMeOrdersCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeOrdersCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeOrdersCountQuery({
 *   variables: {
 *      cartType: // value for 'cartType'
 *   },
 * });
 */
export function useMeOrdersCountQuery(baseOptions?: Apollo.QueryHookOptions<MeOrdersCountQuery, MeOrdersCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeOrdersCountQuery, MeOrdersCountQueryVariables>(MeOrdersCountDocument, options);
      }
export function useMeOrdersCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeOrdersCountQuery, MeOrdersCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeOrdersCountQuery, MeOrdersCountQueryVariables>(MeOrdersCountDocument, options);
        }
export type MeOrdersCountQueryHookResult = ReturnType<typeof useMeOrdersCountQuery>;
export type MeOrdersCountLazyQueryHookResult = ReturnType<typeof useMeOrdersCountLazyQuery>;
export type MeOrdersCountQueryResult = Apollo.QueryResult<MeOrdersCountQuery, MeOrdersCountQueryVariables>;
export function refetchMeOrdersCountQuery(variables?: MeOrdersCountQueryVariables) {
      return { query: MeOrdersCountDocument, variables: variables }
    }
export const MeDownloadsDocument = gql`
    query MeDownloads($limit: Int!, $offset: Int!) {
  me {
    id
    downloads(pagination: {limit: $limit, offset: $offset}) {
      totalCount
      pageInfo {
        offset
        limit
      }
      results {
        id
        pk
        fileName
        downloadTime
        order {
          id
          pk
          token
        }
      }
    }
  }
}
    `;

/**
 * __useMeDownloadsQuery__
 *
 * To run a query within a React component, call `useMeDownloadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeDownloadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeDownloadsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useMeDownloadsQuery(baseOptions: Apollo.QueryHookOptions<MeDownloadsQuery, MeDownloadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeDownloadsQuery, MeDownloadsQueryVariables>(MeDownloadsDocument, options);
      }
export function useMeDownloadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeDownloadsQuery, MeDownloadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeDownloadsQuery, MeDownloadsQueryVariables>(MeDownloadsDocument, options);
        }
export type MeDownloadsQueryHookResult = ReturnType<typeof useMeDownloadsQuery>;
export type MeDownloadsLazyQueryHookResult = ReturnType<typeof useMeDownloadsLazyQuery>;
export type MeDownloadsQueryResult = Apollo.QueryResult<MeDownloadsQuery, MeDownloadsQueryVariables>;
export function refetchMeDownloadsQuery(variables: MeDownloadsQueryVariables) {
      return { query: MeDownloadsDocument, variables: variables }
    }
export const MePatternTransactionsDocument = gql`
    query MePatternTransactions($offset: Int!, $limit: Int!, $patternType: TransactionTypeEnum) {
  me {
    id
    patternTransactions(
      pagination: {offset: $offset, limit: $limit}
      filters: {transactionType: $patternType}
    ) {
      totalCount
      pageInfo {
        limit
        offset
      }
      results {
        ...UserPatternTransactionFragment
      }
    }
  }
}
    ${UserPatternTransactionFragmentDoc}`;

/**
 * __useMePatternTransactionsQuery__
 *
 * To run a query within a React component, call `useMePatternTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMePatternTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMePatternTransactionsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      patternType: // value for 'patternType'
 *   },
 * });
 */
export function useMePatternTransactionsQuery(baseOptions: Apollo.QueryHookOptions<MePatternTransactionsQuery, MePatternTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MePatternTransactionsQuery, MePatternTransactionsQueryVariables>(MePatternTransactionsDocument, options);
      }
export function useMePatternTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MePatternTransactionsQuery, MePatternTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MePatternTransactionsQuery, MePatternTransactionsQueryVariables>(MePatternTransactionsDocument, options);
        }
export type MePatternTransactionsQueryHookResult = ReturnType<typeof useMePatternTransactionsQuery>;
export type MePatternTransactionsLazyQueryHookResult = ReturnType<typeof useMePatternTransactionsLazyQuery>;
export type MePatternTransactionsQueryResult = Apollo.QueryResult<MePatternTransactionsQuery, MePatternTransactionsQueryVariables>;
export function refetchMePatternTransactionsQuery(variables: MePatternTransactionsQueryVariables) {
      return { query: MePatternTransactionsDocument, variables: variables }
    }
export const MePatternPacksInfoDocument = gql`
    query MePatternPacksInfo {
  me {
    id
    patternPacksInfo {
      id
      count
      name
    }
  }
}
    `;

/**
 * __useMePatternPacksInfoQuery__
 *
 * To run a query within a React component, call `useMePatternPacksInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useMePatternPacksInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMePatternPacksInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useMePatternPacksInfoQuery(baseOptions?: Apollo.QueryHookOptions<MePatternPacksInfoQuery, MePatternPacksInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MePatternPacksInfoQuery, MePatternPacksInfoQueryVariables>(MePatternPacksInfoDocument, options);
      }
export function useMePatternPacksInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MePatternPacksInfoQuery, MePatternPacksInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MePatternPacksInfoQuery, MePatternPacksInfoQueryVariables>(MePatternPacksInfoDocument, options);
        }
export type MePatternPacksInfoQueryHookResult = ReturnType<typeof useMePatternPacksInfoQuery>;
export type MePatternPacksInfoLazyQueryHookResult = ReturnType<typeof useMePatternPacksInfoLazyQuery>;
export type MePatternPacksInfoQueryResult = Apollo.QueryResult<MePatternPacksInfoQuery, MePatternPacksInfoQueryVariables>;
export function refetchMePatternPacksInfoQuery(variables?: MePatternPacksInfoQueryVariables) {
      return { query: MePatternPacksInfoDocument, variables: variables }
    }